module.exports = __webpack_public_path__ + "img/project_10.1f8a35c6.jpg";